import { render, staticRenderFns } from "./User-Files.vue?vue&type=template&id=3c5d712d&scoped=true&"
import script from "./User-Files.vue?vue&type=script&lang=js&"
export * from "./User-Files.vue?vue&type=script&lang=js&"
import style0 from "./User-Files.vue?vue&type=style&index=0&id=3c5d712d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d712d",
  null
  
)

export default component.exports